/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_card__review__quite_mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Recht mittelmäßig`
};

const en_poi_card__review__quite_mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Quite mediocre`
};

const es_poi_card__review__quite_mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Bastante mediocre`
};

const fr_poi_card__review__quite_mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Assez médiocre`
};

const it_poi_card__review__quite_mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Abbastanza mediocre`
};

const nl_poi_card__review__quite_mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Redelijk middelmatig`
};

const pt_poi_card__review__quite_mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Bastante medíocre`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__quite_mediocre = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_card__review__quite_mediocre(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_card__review__quite_mediocre", locale)
	if (locale === "de") return de_poi_card__review__quite_mediocre(inputs)
	if (locale === "en") return en_poi_card__review__quite_mediocre(inputs)
	if (locale === "es") return es_poi_card__review__quite_mediocre(inputs)
	if (locale === "fr") return fr_poi_card__review__quite_mediocre(inputs)
	if (locale === "it") return it_poi_card__review__quite_mediocre(inputs)
	if (locale === "nl") return nl_poi_card__review__quite_mediocre(inputs)
	return pt_poi_card__review__quite_mediocre(inputs)
};